module.exports = __webpack_public_path__ + "static/media/mobile-menu-close.d1abd100.svg";